// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalPolicySettings__Zzcds {
  width: 670px;
  height: 575px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.stepArrowIcon__EA_3J {
  margin: 0 15px;
}

.modalBody__bHwP5 {
  flex: 1;
  overflow-y: auto;
  padding: 0 25px;
}
.modalBody__bHwP5::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.modalBody__bHwP5::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.modalBody__bHwP5::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.modalBody__bHwP5::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.settingsText__wfZ_K {
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  padding: 25px 0;
}

.formWrapper__SjIm7 {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  margin-top: 8px;
}

.policyLink__vZn28 {
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  line-height: 16px;
  text-decoration: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: var(--buttons-surface);
  font-weight: 700;
}

.modalFooter__huWhE {
  margin-top: 15px;
  padding: 0 25px 25px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/PrivacyPolicySettingsModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;;AA4EA;EACE,cAAA;AAzEF;;AA4EA;EACE,OAAA;EACA,gBAAA;EACA,eAAA;AAzEF;AAUE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AARJ;AAWE;EACE,+BAAA;EACA,kBAAA;AATJ;AAYE;EACE,8BAAA;EACA,kBAAA;AAVJ;AAaE;EACE,gBAAA;EACA,kBAAA;AAXJ;;AA6DA;EACE,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AA1DF;;AA6DA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;AA1DF;;AA6DA;EACE,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;AA1DF;;AA6DA;EACE,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AA1DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.modalPolicySettings {\n  width: 670px;\n  height: 575px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.stepArrowIcon {\n  margin: 0 15px;\n}\n\n.modalBody {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 25px;\n\n  @include scrollBar;\n}\n\n.settingsText {\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n  padding: 25px 0;\n}\n\n.formWrapper {\n  display: flex;\n  flex-direction: column;\n  row-gap: 8px;\n  margin-top: 8px;\n}\n\n.policyLink {\n  font-family: 'Roboto', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n  text-decoration: none;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  color: var(--buttons-surface);\n  font-weight: 700;\n}\n\n.modalFooter {\n  margin-top: 15px;\n  padding: 0 25px 25px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalPolicySettings": `modalPolicySettings__Zzcds`,
	"stepArrowIcon": `stepArrowIcon__EA_3J`,
	"modalBody": `modalBody__bHwP5`,
	"settingsText": `settingsText__wfZ_K`,
	"formWrapper": `formWrapper__SjIm7`,
	"policyLink": `policyLink__vZn28`,
	"modalFooter": `modalFooter__huWhE`
};
module.exports = ___CSS_LOADER_EXPORT___;
